import FileWatermark from './FileWatermark.component';

export default FileWatermark;